import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=3b980248&lang=pug"
import script from "./o-header.vue?vue&type=script&lang=js"
export * from "./o-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports